import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTE_TITLES } from '../routes';

// Routes with a dynamic id (e.g. /tprm_assessment/:assessmentId) are keyed in
// ROUTE_TITLES by their first segment only, so fall back to that before the
// default title.
const resolveTitle = (pathname) => {
  if (ROUTE_TITLES[pathname]) return ROUTE_TITLES[pathname];
  const firstSegment = pathname.split('/').filter(Boolean)[0];
  return firstSegment ? ROUTE_TITLES[`/${firstSegment}`] : undefined;
};

export default function useDocumentTitle(defaultTitle = 'Cyberinsurify') {
  const location = useLocation();

  useEffect(() => {
    document.title = resolveTitle(location.pathname) || defaultTitle;
  }, [location.pathname, defaultTitle]);
}
